import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'farm';

export const TEST_ID = 'farmSelectPanelField';
